import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import './ClearSeal.css';

const ClearSeal = () => {
  const [iframeError, setIframeError] = useState(false);

  return (
    <div className="clearseal-container">
      <Helmet>
        <title>ClearSeal - Erasys</title>
        <meta
          name="description"
          content="ClearSeal: Natural reading for humans — invisible to OCR and AI. Convert documents to ChromaCamouflage encoded format."
        />
      </Helmet>

      <div className="clearseal-iframe-wrapper">
        {iframeError && (
          <div className="clearseal-error">
            <h2>ClearSeal is currently unavailable</h2>
            <p>Please ensure the ClearSeal server is running.</p>
            <p className="error-hint">Run: <code>cd ClearSeal-Erasys/server && ./start.sh --daemon</code></p>
          </div>
        )}
        <iframe
          src="/clearseal-app"
          title="ClearSeal Application"
          className="clearseal-iframe"
          onError={() => setIframeError(true)}
        />
      </div>
    </div>
  );
};

export default ClearSeal;
